import { render, staticRenderFns } from "./healthKnow.vue?vue&type=template&id=98d74388&scoped=true"
import script from "./healthKnow.vue?vue&type=script&lang=js"
export * from "./healthKnow.vue?vue&type=script&lang=js"
import style0 from "./healthKnow.vue?vue&type=style&index=0&id=98d74388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d74388",
  null
  
)

export default component.exports